export default __webpack_public_path__ + "static/media/cdc-portuguesinha.02fcd4e7.jpg";